// Definitions of the various autocompletion API calls go here.
// The return types are 'lvb' for an array of labelValueBeans, or 'string' for an array of strings.
// TODO: double-check that all these permissionMatrixLevel integers match what Flex uses.
export const completions = {
	attributeHistory: {
		data: [] as string[],
		return: 'lvb',
	},
	search: {
		api: 'getKeywordAutoList',
		args: ['_TERM_', ''], // required to pass a blank second argument.
		return: 'string',
	},
	savedSearch: {
		api: 'getSavedSearchAutoList',
		args: ['_TERM_'],
		return: 'lvb',
	},
	asset: {
		api: 'getAssetAutoList',
		args: ['_TERM_'],
		return: 'lvb',
	},
	category(opts: Record<string, string>) {
		return {
			api: 'getCategoryAutoList',
			args: ['_TERM_', opts['permission-matrix-level'] || 1],
			return: 'lvb',
		};
	},
	categoryName(opts: Record<string, string>) {
		return {
			api: 'getCategoryAutoList',
			args: ['_TERM_', opts['permission-matrix-level'] || 1],
			return: 'string',
		};
	},
	domain: {
		api: 'getDomainAutoList',
		args: ['_TERM_'],
		return: 'lvb',
	},
	user(opts: Record<string, string>) {
		return {
			api: 'getUserAutoList',
			args: ['_TERM_', opts['permission-matrix-level'] || 1],
			// TODO: this is a hack until we move completely away from this old autocomplete system
			return: 'userAutoListItemToLvb',
		};
	},
	sharedResource(opts: Record<string, string>) {
		return {
			api: 'getSharedResourceAutoList',
			args: [opts['resource-name'], '_TERM_', opts.permission || 'read'],
			return: 'lvb',
		};
	},
	group: {
		api: 'getGroupAutoList',
		args: ['_TERM_'],
		return: 'lvb',
	},
	page: {
		// This is local data which will be populated when available
		data: [] as string[],
		return: 'string',
	},
	semanticObjects(opts: Record<string, string>) {
		return {
			api: 'getSemanticObjectAutoList',
			args: ['_TERM_', opts['semantic-object-type-id']],
			return: 'string',
		};
	},
	semanticObjectTypes: {
		api: 'getSemanticObjectTypeAutoList',
		args: ['_TERM_'],
		return: 'lvb',
	},
	tag(opts: Record<string, string>) {
		return {
			api: 'metadataAutoCompleteLookup',
			args: [opts['dataset-id'], '_TERM_'],
			return: 'string',
		};
	},
	cart: {
		api: 'getSavedCartAutoList',
		args: ['_TERM_'],
		return: 'lvb',
	},
	savedCart: {
		// duplicate of above
		api: 'getSavedCartAutoList',
		args: ['_TERM_'],
		return: 'lvb',
	},
	metadataLookup(opts: Record<string, string>) {
		return {
			api: 'metadataDatasetAutoList',
			args: [opts['template-id'], '_TERM_'],
			return: 'string',
		};
	},
	attributeProfile: {
		api: 'getAttributeProfileAutoList',
		args: ['_TERM_'],
		return: 'lvb',
	},
	vocabulary: {
		api: 'vocabularyLookup',
		args: ['_TERM_'],
		return: 'inb',
	},
	vocabularyValue(opts: Record<string, string>) {
		return {
			api: 'vocabularyValueLookup',
			args: [opts['vocabulary-id'], '_TERM_'],
			return: 'string',
		};
	},
};

export default {completions};
